<template>
    <div>
        <Button v-show='!on_wishlist' text='Add to wishlist' theme='light' :wide_letter_spacing='true' @click='addToWishList'/>
        <Button v-show='on_wishlist' text='Remove from wishlist' theme='light' :wide_letter_spacing='true' @click='removeFromWishList'/>
    </div>
</template>

<script>
import Button from '@/ecom/components/buttons/Button.vue';
import {checkAuth} from "@/global/modules/functions.js";
export default {
    components:{Button},
    props: ['product'],
    data(){
        return{
            on_wishlist: false
        }
    },
    methods:{
        async checkWishList(){
            let response = await fetch(`/api/wishlist/check?product_id=${this.product.code}`, {
                method: 'GET',
                headers: {'Content-Type': 'application/json'},
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
               this.on_wishlist = results.on_wishlist;
            }
        },
        async addToWishList(){
            let response = await fetch(`/api/wishlist`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    product_id: this.product.code
                }),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                  if(!results.logged_in){
                    this.$router.push('/login');
                }
                else{
                    this.on_wishlist = true;
                }
            }
        },
        async removeFromWishList(){
            let response = await fetch(`/api/wishlist`, {
                method: 'DELETE',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    product_id: this.product.code
                }),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                if(!results.logged_in){
                    this.$router.push('/login');
                }
                else{
                    this.on_wishlist = false;
                }
            }
        }
    },
    watch:{
        'product': function(){
            this.checkWishList();
        }
    }
}
</script>

<style lang="scss" scoped>
.add-to-wish-list-container{
    width: 400px;
}
</style>